import React from 'react';
import '../App.css';
import cfl from '../config.json';
import $ from 'jquery';
import config from '.././config.json';
import moment from 'moment';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import {
    Form, Input, Tooltip, Icon, Select, Modal,
    Button, DatePicker, InputNumber, Spin, notification, TimePicker, Row, Col
} from 'antd';

import { Redirect } from 'react-router';
import LoginForm from '../LoginForm.js';

const { RangePicker } = DatePicker;
const FormItem = Form.Item;
const Option = Select.Option;

class AddECRT extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            login: true,
            certification: {
                ID: -1, Name: '', NumberOfYearsValid: ''
            },
            certificationList: [],
        };
        this.certificationDisplayList;
    }

    /**
     * This code runs after a component is rendered.
     * As a result this is where we retrieve our data from the server.
     */
    componentDidMount() {
        LoginForm.ValidateServerToken(() => { this.setState({ login: false }) });
        this.certificationDropdown();        
    }
    
    certificationDropdown = () => {
        this.certificationDisplayList = [];
        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/view/getecrtstudent`
        })
            .done((data) => {
                for (let i = 0; i < data.length; i++) {
                    var optDis = data[i].Name;
                    this.certificationDisplayList.push(
                        <Option key={data[i].ID}>{optDis}</Option>
                    );
                }
                this.certificationDisplayList.push(
                    <Option key="-1">Other</Option>
                );
                this.setState({
                    certificationList: data
                });
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('failed to get data');
            });

    }

    /**
    * From submit event
    */
    handleSubmit = (e) => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const certification = this.state.certification;
                certification.ID = values.display;
                certification.Name = values.certificationName;
                certification.NumberOfYearsValid = values.valid;
                this.setState({
                    certification
                });

                $.ajax({
                    type: 'POST',
                    url: `${config.serverUrl}/api/view/insertecrtcert`,
                    data: this.state.certification
                })
                    .done((data) => {
                        this.handleCancel();
                        this.certificationDropdown();
                        const modal = Modal.success({
                            title: "Certification update successful!",
                            content: 'Certification has been successfully updated.',

                        });
                    })
                    .fail((jqXhr) => {
                        console.log('failed to register');
                    });



            }
            else {
                console.log(err);
            }
        });

    }

    handleCancel = () => {

        this.setState({
           certification: {
                Id: -1, Name: '', NumberOfYearsValid: ''
            }
        });
        this.props.form.resetFields();
        window.location.href = '#/admin/admin';

    }

    handleChangeCertification = (value) => {
        this.props.form.resetFields();
        this.certificationdropdown = value;
        for (let i = 0; i < this.state.certificationList.length; i++) {
            if (this.state.certificationList[i].ID == value) {
                this.setState({
                    certification: this.state.certificationList[i]
                });
                break;
            }
            else {
                this.setState({
                    certification: {
                        ID: -1, Name: '', NumberOfYearsValid: ''
                    }
                });
            }

        }
    }

    /**
     * Render function
     */
    render() {
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 14 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 14,
                    offset: 6,
                },
            },
        };


        return (
            <div>{
                this.state.login ?
                    <div>
                    <h2>Add/Edit Certificate</h2>
                    <hr />
                    <div className='forms'>
                        <Form>
                            <FormItem
                                {...formItemLayout}
                                label="Select a certification from the List"
                            >
                                {getFieldDecorator('display', {
                                    initialValue: "-1",

                                })(
                                    <Select
                                        showSearch
                                        style={{ width: '60%' }}
                                        optionFilterProp="children"
                                        onChange={this.handleChangeCertification}
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {this.certificationDisplayList}
                                    </Select>)}

                            </FormItem>
                            <FormItem {...formItemLayout} label="Certification Name">
                                    {getFieldDecorator('certificationName', {
                                        initialValue: this.state.certification.Name,
                                    rules: [{
                                        required: true, message: 'Please enter name of the certification!',
                                    }],
                                })(<Input/>)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="Number of years valid" >
                                    {getFieldDecorator('valid', {
                                        initialValue: this.state.certification.NumberOfYearsValid,
                                    rules: [{
                                        required: true, message: 'Required!',
                                    }],
                                })(<Input/>)}
                            </FormItem>
                           
                            <Row>
                                <Col span={24}>
                                    <button className="btn btn-default" onClick={() => this.handleCancel()}>Cancel</button>
                                    <button style={{ marginLeft: 8 }} type="submit" className="btn btn-default" onClick={() => this.handleSubmit()}>Insert/Update</button>

                                </Col>
                            </Row>

                        </Form>
                    </div>
                   </div>
                    : <Redirect to="/login" replace />
            }</div>
        );
    }

}

const WrappedAddECRT = Form.create()(AddECRT);

export default WrappedAddECRT;


// WEBPACK FOOTER //
// ./src/Admin/AddECRT.js